import type { ReactNode } from "react";
import { cn } from "../../utils/cn";
import { Check } from "lucide-react";

interface OptionCardProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const OptionCard = ({ icon, title, subtitle, selected, onClick, disabled, className }: OptionCardProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={cn(
      "relative text-left rounded-xl border p-4 transition-all",
      selected ? "border-ember/60 bg-ember/10" : "border-line bg-surface hover:border-line-strong hover:bg-white/[0.02]",
      disabled && "opacity-40 cursor-not-allowed",
      className
    )}
  >
    <div className="flex items-center gap-3">
      {icon && <span className={cn("shrink-0", selected ? "text-ember" : "text-fg-muted")}>{icon}</span>}
      <div className="min-w-0 flex-1">
        <div className={cn("font-medium", selected ? "text-ember" : "text-fg")}>{title}</div>
        {subtitle && <div className="text-xs text-fg-muted mt-0.5">{subtitle}</div>}
      </div>
      {selected && <Check size={16} className="text-ember shrink-0" />}
    </div>
  </button>
);
